import { token } from '@atlaskit/tokens';

/**
 * Design decisions for the drop indicator's main line
 */
export const line = {
	borderRadius: 0,
	thickness: 2,
	backgroundColor: token('color.border.selected'),
};
